import { jsx } from 'react/jsx-runtime';

const X = ({ width = 24, height = 24, fill = "#000", className }) => {
  return /* @__PURE__ */ jsx("span", { className, children: /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 24 24",
      fill: "none",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.2707 5.63054C17.5627 5.3367 18.0364 5.3367 18.3283 5.63054C18.62 5.92427 18.6198 6.40021 18.3283 6.69401L13.0568 11.9997L18.3283 17.3053C18.6202 17.5992 18.6202 18.076 18.3283 18.3698C18.0364 18.6636 17.5627 18.6636 17.2707 18.3698L11.9992 13.0641L6.72872 18.3698C6.43679 18.6636 5.96305 18.6636 5.6711 18.3698C5.37916 18.076 5.37916 17.5992 5.6711 17.3053L10.9416 11.9997L5.6711 6.69401C5.37936 6.40019 5.3793 5.92433 5.6711 5.63054C5.96305 5.3367 6.43678 5.3367 6.72872 5.63054L11.9992 10.9352L17.2707 5.63054Z",
          fill
        }
      )
    }
  ) });
};

export { X };
